module.exports = __webpack_public_path__ + "img/bg1.53f0d4c9.png";